import { connect } from 'react-redux';
import { bindActionCreators } from 'multireducer';

import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { isFetching } from 'shared/selectors/channel-videos';
import { loadFirstPage, toFirstPage, goBack, goForward } from 'widget/redux/client/actions/paginated-channel-videos';

import DataLoader from 'shared/data-components/_data-loader';

export const DATA_KEY = 'paginated-videos';

@connect(state => ({
  videoByIds: getVideosGroupedByIds(state),
  paginatedChannelVideos: state.lazyVideoLists[DATA_KEY],
  isFetching: isFetching(state),
}),
  dispatch => bindActionCreators({
    loadFirstPage,
    toFirstPage,
    goBack,
    goForward,
  }, dispatch, DATA_KEY)
)
export default class PaginatedChannelVideosLoader extends DataLoader {
  static displayName = 'PaginatedChannelVideosLoader';

  static propTypes = {
    paginatedChannelVideos: React.PropTypes.object,
    loadFirstPage: React.PropTypes.func,
    toFirstPage: React.PropTypes.func,
    goBack: React.PropTypes.func,
    goForward: React.PropTypes.func,
    channelId: React.PropTypes.string,
    videosPerUIPage: React.PropTypes.number,
    searchQuery: React.PropTypes.string,
    searchQueryField: React.PropTypes.string,
  };

  dependencies = [
    'channelId',
    'videosPerUIPage',
    'searchQuery',
    'searchQueryField',
  ];

  loadData() {
    const { searchQuery, searchQueryField, videosPerUIPage, channelId, loadFirstPage } = this.props;

    if (!channelId || !videosPerUIPage) {
      return;
    }

    // TODO: move loadFirstPage code here
    return loadFirstPage(channelId, {
      perUIPage: videosPerUIPage,
      [searchQueryField]: searchQuery,
    });
  }

  get childProps() {
    const { videoByIds, isFetching, toFirstPage, goBack, goForward, paginatedChannelVideos } = this.props;
    return { videoByIds, paginatedChannelVideos: {
        ...paginatedChannelVideos,
        isFetching,
        toFirstPage,
        goBack,
        goForward,
        fetch: this.loadDataDebounced,
      },
    };
  }

}



// WEBPACK FOOTER //
// ./src/widget/data-components/paginated-channel-videos.js